import {
  CONSERVATION_CL,
  COVERAGE_CL,
  FREQ_CL,
  GERMLINE_CL,
  LIGHT,
  OTHER_CL,
  PATHOGENICITY_CL,
  READ_RATIO_CL,
  SELECTION_CL,
  SOMATIC_CL,
  ROH_CL,
  PHASING_CL,
  STRUCT_CL,
  CALL_CL,
  WINDOW,
  GREEDY,
  TRANSCRIPT_CL,
  PATHOGENICITY_CL_DELLY,
  IMPACT_NULL_VARS_CL,
  IMPACT_OTHER_CL,
  COVERAGE_CL_DELLY,
  NO_ANTIALIASING,
  ANTIALIASING,
} from "../../constants/options";
import {
  BLACK_WHITE,
  COOL,
  VIRIDIS_COOL,
  YELLOW_RED,
  TAILWIND,
  GRAY_TONE,
  RED_GREEN,
  TABLEAU,
  BLUE_RED,
  TURBO,
  RED_BLUE,
} from "../../constants/colors";
import ls from "../../../../common/helpers/localStorageActions";

export function getDefaultColorScales() {
  return {
    [TRANSCRIPT_CL]: TAILWIND,
    [FREQ_CL]: COOL,
    [STRUCT_CL]: TABLEAU,
    [SOMATIC_CL]: VIRIDIS_COOL,
    [GERMLINE_CL]: YELLOW_RED,
    [OTHER_CL]: GRAY_TONE,
    [PATHOGENICITY_CL]: RED_GREEN,
    [READ_RATIO_CL]: BLUE_RED,
    [CONSERVATION_CL]: RED_GREEN,
    [ROH_CL]: TABLEAU,
    [PHASING_CL]: TURBO,
    [SELECTION_CL]: BLACK_WHITE,
    [COVERAGE_CL]: BLUE_RED,
    [CALL_CL]: BLUE_RED,
    [PATHOGENICITY_CL_DELLY]: RED_GREEN,
    [COVERAGE_CL_DELLY]: RED_BLUE,
    [IMPACT_NULL_VARS_CL]: YELLOW_RED,
    [IMPACT_OTHER_CL]: COOL,
  };
}

const px = window.devicePixelRatio;

export function getDefaultSettings() {
  return {
    theme: LIGHT,
    themeCl: `themed ${LIGHT}`,
    fullScreenMode: WINDOW,
    gestureControl: GREEDY,
    zoomTrackingFactor: "1",
    antialiasingMode: (px || 1) > 1.5 ? NO_ANTIALIASING : ANTIALIASING,
  };
}

export function getUserSettings() {
  const defPreferences = getDefaultSettings();
  const defColorScales = getDefaultColorScales();
  const storedPreferences = ls.getPulsarConf() || {};
  return { ...defPreferences, ...defColorScales, ...storedPreferences };
}

export function storeUserSettings(prefs) {
  ls.setPulsarConf(prefs);
}
